import { memo } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';
import { getPageRange } from '../utils/apiServiceUtils';
import { K, apiT } from '../apiServiceI18n';

function ApiServiceTablePagination({ page, pageSize, totalCount, onPageChange, disabled }) {
  const { t } = useTranslation();
  const { start, end, totalPages, page: safePage } = getPageRange(page, pageSize, totalCount);
  const canPrev = safePage > 0;
  const canNext = safePage + 1 < totalPages;

  if (totalCount <= 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
        px: 1.5,
        py: 1.25,
        borderTop: '1px solid #d5d9e0',
        bgcolor: '#eceff3',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {apiT(K.API_SVC_TABLE_PAGINATION, { 0: start, 1: end, 2: totalCount })}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={0.5}>
        <IconButton
          size="small"
          aria-label={t(K.API_SVC_PREV_PAGE)}
          disabled={disabled || !canPrev}
          onClick={() => onPageChange(safePage - 1)}
        >
          <ChevronLeftIcon />
        </IconButton>

        <Typography variant="body2" sx={{ minWidth: 100, textAlign: 'center' }}>
          {apiT(K.API_SVC_PAGE_OF, { 0: safePage + 1, 1: totalPages }).trim()}
        </Typography>

        <IconButton
          size="small"
          aria-label={t(K.API_SVC_NEXT_PAGE)}
          disabled={disabled || !canNext}
          onClick={() => onPageChange(safePage + 1)}
        >
          <ChevronRightIcon />
        </IconButton>
      </Stack>
    </Box>
  );
}

export default memo(ApiServiceTablePagination);
